<div class="AmCalendarMonth" *ngFor="let year of monthsArr; let x = index;">
  <span class="AmCalendarMonth-year fs-24px lh-32px fw-medium-x" [ngClass]="{ 'AmCalendarMonth-year--topSize': x >= 1 }">
    {{ year.key }}
  </span>
  <div class="AmCalendarMonth-list">
    <div
      class="AmCalendarMonth-item fs-28px lh-42px fw-regular "
      *ngFor="let month of year.value; let i = index;"
      [ngStyle]="{ 'color': monthSelected == month.link ? '#FA0073' : '#035CF7' }"
    >
      <span>
        {{ month.dateCreate | localizedDate: 'MMM' | lowercase }}.
      </span>
    </div>
  </div>
</div>